import {ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit, signal} from '@angular/core';
import {WikiListComponent} from '../wiki-list/wiki-list.component';
import {WikiToolbarComponent} from '../wiki-toolbar/wiki-toolbar.component';
import {Store} from '@ngrx/store';
import {selectWikiList, selectWikiLoading} from 'src/app/core/store/wiki/wiki.selector';
import {GetAllWikiGroupsAction} from 'src/app/core/store/wiki/wiki.action';
import {TitleService} from 'src/app/core/page/title.service';
import {CommonModule} from '@angular/common';
import {OphLoadingModule} from 'src/app/shared/design/oph-loading/oph-loading.module';
import {Subject, Subscription, takeUntil} from 'rxjs';
import {WikiGroup} from '../models/wiki.model';
import {generateRandomColor} from 'src/app/shared/utils/color/get-random-color';
import {OphDrawerModule} from '../../shared/design/oph-drawer/oph-drawer.module';
@Component({
  selector: 'wiki-main',
  standalone: true,
  imports: [WikiListComponent, WikiToolbarComponent, CommonModule, OphLoadingModule, OphDrawerModule],
  templateUrl: './wiki-main.component.html',
  styleUrl: './wiki-main.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WikiMainComponent implements OnInit, OnDestroy {
  private titleService = inject(TitleService);
  private store$ = inject(Store);
  public wikiGroups$ = this.store$.select(selectWikiList);
  public loading$ = this.store$.select(selectWikiLoading);
  private unsubscribe$ = new Subject<void>();
  randomColors = signal<string[]>([]);

  ngOnInit(): void {
    this.subscribeToWikiGroups();
    this.titleService.setPageTitle('Wiki');
    this.fetchWikiGroups();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  subscribeToWikiGroups(): Subscription {
    return this.wikiGroups$.pipe(takeUntil(this.unsubscribe$)).subscribe({
      next: groups => {
        this.generateRandomColors(groups);
      },
    });
  }

  generateRandomColors(wikiGroups: WikiGroup[]): void {
    this.randomColors.set(wikiGroups.map(() => generateRandomColor()));
  }

  fetchWikiGroups() {
    this.store$.dispatch(new GetAllWikiGroupsAction({}));
  }
}
